import { MarketplaceAnalyticsContext } from '@atlassian/mpac-analytics';
import { lazyForPaint, LazySuspense } from 'react-loosely-lazy';

import BaseRouteHandler from '../../Routes/components/common/routeHandlers/BaseRouteHandler';

const BundlePageCodeSplit = lazyForPaint(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "chunk-bundlePage" */ './components/BundlePage'
    )
);

const RouteHandler = () => {
  return (
    <BaseRouteHandler scrollToTopOnPathChange includePartnerQuickLinks>
      <MarketplaceAnalyticsContext properties={{ source: 'bundle_page' }}>
        <LazySuspense fallback={<div />}>
          <BundlePageCodeSplit />
        </LazySuspense>
      </MarketplaceAnalyticsContext>
    </BaseRouteHandler>
  );
};

export default RouteHandler;
